import * as React from 'react';
import { MenuItem, Select } from '@mui/material';
import classNames from 'classnames';
import { Align } from '../../types';
import { selectorMenuProps } from './utils';
import AccurityIcon from '../../../icon/components/AccurityIcon';
var IconMenuItem = function (_a) {
    var className = _a.className, iconName = _a.iconName, value = _a.value;
    return (React.createElement(MenuItem, { className: "iconFilter__item", key: "iconColumn_" + value, value: value },
        React.createElement(AccurityIcon, { iconName: iconName, className: classNames('iconFilter_itemIcon iconColumn', className) })));
};
var IconFilter = function (_a) {
    var iconColumn = _a.iconColumn, onFilterChange = _a.onFilterChange;
    var handleOnChange = function (event) {
        onFilterChange(iconColumn, event.target.value);
    };
    var style = {};
    if (iconColumn.align === Align.RIGHT) {
        style.textAlign = 'right';
    }
    else if (iconColumn.align === Align.LEFT) {
        style.textAlign = 'left';
    }
    else if (iconColumn.align === Align.CENTER) {
        style.textAlign = 'center';
    }
    return (React.createElement(Select, { fullWidth: true, className: "columnFilter iconFilter", disableUnderline: true, displayEmpty: true, MenuProps: selectorMenuProps, style: style, onChange: handleOnChange, value: iconColumn.filter },
        (iconColumn.graphics || []).map(IconMenuItem),
        React.createElement(MenuItem, { className: "iconFilter__item", key: "iconColumn_EMPTY", value: "" },
            React.createElement("span", { className: "iconFilter__optionAll" }, "ALL"))));
};
export default IconFilter;
//# sourceMappingURL=IconFilter.js.map